<template src="./SideFilter.html"></template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        locked: { type: Boolean, default: false },
        label: { type: String, default: "Filter" }
    },
    emits: ["filterChangeState"],
    data() {
        return {
            isActive: false
        };
    },
    computed: {
        classes(): string[] {
            const classes = ["side-filter"];
            if (this.isActive) {
                classes.push("active");
            }
            return classes;
        }
    },
    methods: {
        changeState(): void {
            this.isActive = !this.isActive;
            this.$emit("filterChangeState", this.isActive);
        }
    }
});
</script>

<style lang="scss" scoped src="./SideFilter.scss"></style>
